import { DatePicker, Form, TimePicker } from 'antd';
import React, { useMemo } from 'react';

import { COMPONENT_TYPE, FilterComponentInput } from '@core/offices/types';

const InputRender = (inputProps: React.InputHTMLAttributes<HTMLInputElement>) => {
  return <input {...inputProps} style={{ textAlign: 'start', overflow: 'auto', fontSize: '14px' }} />;
};

const DateInput = (props: FilterComponentInput) => {
  const sharedProps = useMemo(() => {
    return {
      value: props.value,
      onChange: (e: any) => props.handleChange(e),
      placeholder: props.filter.placeholder,
      className: 'w-full rounded-3xl',
      InputRender,
    };
  }, [props.value, props.filter.placeholder]);

  return (
    <Form.Item label={props.filter.label}>
      {props.filter.componentType !== COMPONENT_TYPE.TIME && (
        <DatePicker
          showTime={props.filter.componentType === COMPONENT_TYPE.DATETIME}
          {...sharedProps}
          format={`dddd, MMMM DD${props.filter.componentType === COMPONENT_TYPE.DATETIME ? ' HH:mm' : ''}`}
        />
      )}
      {props.filter.componentType === COMPONENT_TYPE.TIME && <TimePicker {...sharedProps} format="HH:mm" />}
    </Form.Item>
  );
};
export default DateInput;
